const DS_UF_NOMES = {
  AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceará',
  DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás', MA: 'Maranhão',
  MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Pará',
  PB: 'Paraíba', PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí', RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondônia', RR: 'Roraima',
  SC: 'Santa Catarina', SP: 'São Paulo', SE: 'Sergipe', TO: 'Tocantins'
};

class EstimateShipping extends HTMLElement {
  constructor() {
    super();
    this.initShippingCalc = this.initShippingCalc.bind(this);
    this.generateShippingRates = this.generateShippingRates.bind(this);
    this.onModalOpen = this.onModalOpen.bind(this);
    this._listenersBound = false;
  }

  connectedCallback() {
    this.ensureInstanceIds();
    this.initShippingCalc();
    this.bindEventListeners();
    document.addEventListener('modal-drawer:opened', this.onModalOpen);
  }

  disconnectedCallback() {
    document.removeEventListener('modal-drawer:opened', this.onModalOpen);
    this._listenersBound = false;
  }

  onModalOpen(event) {
    if (event.detail?.id !== 'calc-shipping-modal') return;
    if (!this.isConnected || !event.target?.contains(this)) return;
    this.initShippingCalc();
  }

  ensureInstanceIds() {
    if (this.dataset.instanceId) return;

    const instanceId = `es-${Math.random().toString(36).slice(2, 9)}`;
    this.dataset.instanceId = instanceId;

    const country = this.querySelector('[data-shipping-field="country"]');
    const province = this.querySelector('[data-shipping-field="province"]');
    const provinceWrapper = this.querySelector('[data-shipping-field="province-wrapper"]');
    const zip = this.querySelector('[data-shipping-field="zip"]');
    const button = this.querySelector('[data-shipping-field="button"]');
    const alertDanger = this.querySelector('[data-shipping-field="alert-danger"]');
    const alertWarning = this.querySelector('[data-shipping-field="alert-warning"]');
    const alertSuccess = this.querySelector('[data-shipping-field="alert-success"]');

    if (country) country.id = `${instanceId}-country`;
    if (province) province.id = `${instanceId}-province`;
    if (provinceWrapper) provinceWrapper.id = `${instanceId}-province-wrapper`;
    if (zip) zip.id = `${instanceId}-zip`;
    if (button) button.id = `${instanceId}-button`;
    if (alertDanger) alertDanger.id = `${instanceId}-alert-danger`;
    if (alertWarning) alertWarning.id = `${instanceId}-alert-warning`;
    if (alertSuccess) alertSuccess.id = `${instanceId}-alert-success`;
  }

  initCountryProvinceSelector() {
    if (typeof Shopify === 'undefined' || typeof Shopify.CountryProvinceSelector !== 'function') {
      return;
    }

    const country = this.querySelector('[data-shipping-field="country"]');
    const province = this.querySelector('[data-shipping-field="province"]');
    const provinceWrapper = this.querySelector('[data-shipping-field="province-wrapper"]');

    if (!country?.id || !province?.id || !provinceWrapper?.id) return;

    new Shopify.CountryProvinceSelector(country.id, province.id, {
      hideElement: provinceWrapper.id,
    });
  }

  initShippingCalc() {
    this.ensureInstanceIds();
    this.initCountryProvinceSelector();
    this.style.display = 'block';
  }

  bindEventListeners() {
    if (this._listenersBound) return;
    this._listenersBound = true;

    const country = this.querySelector('[data-shipping-field="country"]');
    if (country) {
      country.addEventListener('change', () => {
        this.initCountryProvinceSelector();
      });
    }

    const zip = this.querySelector('[data-shipping-field="zip"]');
    if (zip) {
      zip.addEventListener('input', () => {
        let digits = zip.value.replace(/\D/g, '').slice(0, 8);
        zip.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
        if (!this._calculando) this.clearAlerts(); // some resultado antigo ao editar o CEP
        if (digits.length === 8) this.atualizarEstadoPeloCep(digits);
      });
      zip.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.generateShippingRates(this.querySelector('[data-shipping-field="button"]'));
      });
    }

    const button = this.querySelector('[data-shipping-field="button"]');
    if (button) {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.generateShippingRates(button);
      });
    }
  }

  async buscarUfPeloCep(digits) {
    try {
      const resp = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
      if (!resp.ok) return null;
      const data = await resp.json();
      if (data.erro) return { erro: true };
      return { uf: data.uf, cidade: data.localidade, rua: data.logradouro, bairro: data.bairro };
    } catch (_error) {
      return null; // ViaCEP indisponivel: segue com o estado escolhido manualmente
    }
  }

  aplicarUfNoSelect(uf) {
    const nome = DS_UF_NOMES[uf] || uf;
    const select = this.querySelector('[data-shipping-field="province"]');
    if (!select) return nome;
    const opcao = [...select.options].find(
      (o) => o.value === nome || o.text === nome || o.value === uf
    );
    if (opcao) {
      select.value = opcao.value;
      return opcao.value;
    }
    return nome;
  }

  async atualizarEstadoPeloCep(digits) {
    const consulta = await this.buscarUfPeloCep(digits);
    if (consulta && consulta.uf) this.aplicarUfNoSelect(consulta.uf);
  }

  clearAlerts() {
    for (const field of ['alert-danger', 'alert-warning', 'alert-success']) {
      const alert = this.querySelector(`[data-shipping-field="${field}"]`);
      if (!alert) continue;
      alert.innerHTML = '';
      alert.setAttribute('hidden', 'hidden');
    }
  }

  setLoading(button, isLoading) {
    if (!button) return;
    const loadingSpinner = button.querySelector('.loading__spinner');
    button.classList.toggle('loading', isLoading);
    button.disabled = isLoading;
    if (loadingSpinner) loadingSpinner.classList.toggle('hidden', !isLoading);
  }

  async generateShippingRates(btn) {
    if (this._calculando) return; // evita cliques duplos atropelando o calculo
    this._calculando = true;
    this.clearAlerts();
    this.setLoading(btn, true);
    this._enderecoCep = null;

    try {
      const country = this.querySelector('[data-shipping-field="country"]')?.value?.trim();
      let province = this.querySelector('[data-shipping-field="province"]')?.value?.trim();
      let zip = this.querySelector('[data-shipping-field="zip"]')?.value?.trim();

      if (!country || !zip) {
        this.showAlert('alert-danger', '<p>Preencha o país e o CEP para calcular o frete.</p>');
        return;
      }

      if (country === 'Brazil' || country === 'Brasil') {
        const digits = zip.replace(/\D/g, '');
        if (digits.length !== 8) {
          this.showAlert('alert-danger', '<p>CEP incompleto. Digite os 8 números do CEP.</p>');
          return;
        }
        zip = digits.slice(0, 5) + '-' + digits.slice(5);

        // Estado sai exclusivamente do CEP (o seletor esta oculto): consulta com nova tentativa
        let consulta = await this.buscarUfPeloCep(digits);
        if (!consulta) {
          await new Promise((resolve) => setTimeout(resolve, 800));
          consulta = await this.buscarUfPeloCep(digits);
        }
        if (consulta && consulta.erro) {
          this.showAlert('alert-danger', '<p>CEP não encontrado. Confira os números e tente novamente.</p>');
          return;
        }
        if (!consulta || !consulta.uf) {
          this.showAlert('alert-danger', '<p>Não foi possível consultar seu CEP agora. Tente novamente em alguns segundos.</p>');
          return;
        }
        province = this.aplicarUfNoSelect(consulta.uf);
        this._enderecoCep = consulta;
      }

      const params = new URLSearchParams({
        'shipping_address[zip]': zip,
        'shipping_address[country]': country,
        'shipping_address[province]': province || '',
      });

      const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?${params.toString()}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!prepareResponse.ok) {
        let message = '<p>Não foi possível calcular o frete. Verifique o CEP e tente novamente.</p>';
        try {
          const errorData = await prepareResponse.json();
          const details = Object.values(errorData)
            .flat()
            .map((value) => `<p>${String(value)}</p>`)
            .join('');
          if (details) message = details;
        } catch (_error) {
          // Keep generic message when Shopify does not return JSON.
        }
        this.showAlert('alert-danger', message);
        return;
      }

      // A transportadora pode demorar alguns segundos: re-pergunta ate a resposta chegar
      let rates = null;
      for (let tentativa = 0; tentativa < 8; tentativa++) {
        const asyncResponse = await fetch(`/cart/async_shipping_rates.json?${params.toString()}`, {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
          },
        });

        if (!asyncResponse.ok) {
          this.showAlert('alert-danger', '<p>Não foi possível obter as opções de frete. Tente novamente.</p>');
          return;
        }

        let data = null;
        try {
          data = await asyncResponse.json();
        } catch (_error) {
          data = null; // corpo vazio/incompleto = Shopify ainda calculando: tenta de novo
        }
        if (data && Array.isArray(data.shipping_rates)) {
          rates = data.shipping_rates;
          break;
        }
        await new Promise((resolve) => setTimeout(resolve, 1500));
      }

      if (rates === null) {
        this.showAlert('alert-danger', '<p>O cálculo está demorando. Aguarde alguns segundos e tente novamente.</p>');
        return;
      }

      if (!rates.length) {
        this.showAlert('alert-warning', '<p>Nenhuma opção de frete encontrada para este endereço.</p>');
        return;
      }

      const formatarPreco = (rate) => {
        const valor = Number(rate.price);
        if (rate.currency === 'BRL' && !Number.isNaN(valor)) {
          return valor === 0 ? 'Grátis' : 'R$ ' + valor.toFixed(2).replace('.', ',');
        }
        return `${rate.price} ${rate.currency}`;
      };

      const formatarPrazo = (rate) => {
        const dias = rate.delivery_days;
        if (!Array.isArray(dias) || dias.length === 0 || dias[0] == null) return '';
        const min = Number(dias[0]);
        const max = Number(dias[dias.length - 1]) || min;
        if (max <= 0) return ''; // prazo zerado: melhor nao prometer nada
        if (min === max) return min === 1 ? 'entrega em 1 dia útil' : `entrega em ${min} dias úteis`;
        return `entrega de ${min} a ${max} dias úteis`;
      };

      const html = rates
        .map((rate) => {
          const prazo = formatarPrazo(rate);
          return `<li class="ds-frete-opcao">
            <span class="ds-frete-info">
              <strong class="ds-frete-nome">${rate.presentment_name}</strong>
              ${prazo ? `<span class="ds-frete-prazo">${prazo}</span>` : ''}
            </span>
            <span class="ds-frete-preco">${formatarPreco(rate)}</span>
          </li>`;
        })
        .join('');

      const endereco = this._enderecoCep;
      const linhaRua = endereco ? [endereco.rua, endereco.bairro].filter(Boolean).join(', ') : '';
      const enderecoHtml = endereco && endereco.cidade
        ? `<p class="ds-frete-endereco">Entrega para: ${linhaRua ? linhaRua + ' — ' : ''}${endereco.cidade}/${endereco.uf}</p>`
        : '';

      this.showAlert('alert-success', `${enderecoHtml}<ul class="ds-frete-lista">${html}</ul>`);
    } catch (error) {
      console.error('[EstimateShipping] generateShippingRates error:', error);
      this.showAlert('alert-danger', '<p>Erro ao calcular o frete. Tente novamente.</p>');
    } finally {
      this._calculando = false;
      this.setLoading(btn, false);
    }
  }

  showAlert(field, html) {
    const alert = this.querySelector(`[data-shipping-field="${field}"]`);
    if (!alert) return;
    alert.innerHTML = html;
    alert.removeAttribute('hidden');
  }
}

if (!customElements.get('estimate-shipping')) {
  customElements.define('estimate-shipping', EstimateShipping);
}
